export default __webpack_public_path__ + "static/media/battery.54ca08e9.svg";